import { APP_CONFIG } from '../config/appConfig.js';

let ldJsonScript = null;

function setMetaTag(name, content, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content || '');
}

export const seoService = {
  update({ title, description, image, url, schema }) {
    const fullTitle = title 
      ? `${title} | ${APP_CONFIG.appName}` 
      : `${APP_CONFIG.appName} | ${APP_CONFIG.tagline}`;
    
    document.title = fullTitle;
    
    setMetaTag('description', description || APP_CONFIG.tagline);
    setMetaTag('og:title', fullTitle, true);
    setMetaTag('og:description', description || APP_CONFIG.tagline, true);
    setMetaTag('og:url', url || window.location.href, true);
    if (image) {
      setMetaTag('og:image', image, true);
    }

    // JSON-LD Schema
    if (schema) {
      if (!ldJsonScript) {
        ldJsonScript = document.createElement('script');
        ldJsonScript.type = 'application/ld+json';
        document.head.appendChild(ldJsonScript);
      }
      ldJsonScript.textContent = JSON.stringify(schema);
    } else if (ldJsonScript) {
      ldJsonScript.remove();
      ldJsonScript = null;
    }
  }
};
